module.exports = __webpack_public_path__ + "static/media/medal-third.fddd11ae.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icons/medal-third.svg
// module id = 3177
// module chunks = 7